/**
 * Created by roi on 2/05/17.
 */
import { ESTACIO_OBTENIR, OBSERVACIO_INICIALITZAR } from '../../../actions/actionTypes.js';

const ESTAT_INICIAL_ESTACIONS = [];

const totes = (state = ESTAT_INICIAL_ESTACIONS, action) => {
    switch (action.type) {
        case ESTACIO_OBTENIR:
            return action.dadesEstacions;
        case OBSERVACIO_INICIALITZAR:
            return ESTAT_INICIAL_ESTACIONS;
        default:
            return state;
    }
};

export default totes;



// WEBPACK FOOTER //
// ./src/reducers/observacio/estacio/totes.js